module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1OTkuMDk4IiBoZWlnaHQ9IjYwMi43MjQiIHZpZXdCb3g9IjAgMCA1OTkuMDk4IDYwMi43MjQiPgogIDxwYXRoIGlkPSJQYXRoXzc3IiBkYXRhLW5hbWU9IlBhdGggNzciIGQ9Ik01OTkuMS0uMzQ2VjYwMi4zNzdIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC4zNDYpIiBmaWxsPSIjZTM1YTJhIiBvcGFjaXR5PSIwLjIiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./assets/img/orange-corner.svg
// module id = 12
// module chunks = 0